// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"df7f5f82b34ef92fcd77","966":"76697483ef0100b9d528"}[chunkId] + ".js";
};